import { Modelo } from '@ext/index';
import * as Types from './ModificacionDeEstado.types';
import * as Pedidos from '../';
import moment, { Moment } from 'moment';

export class IModificacionDeEstado extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Pedido: number = 0;
    public Estado: Pedidos.Estados;
    public Fecha: Moment = moment();
    public Usuario: number = 0;


    public getJson(): any {
        let json: any = {};

        json.pedido = this.Pedido;
        json.estado = this.Estado.Id;
        json.fecha = this.Fecha.toSQL();
        json.usuario = this.Usuario;


        return json;
    }


    public set(): boolean {

        this.Pedido = this.Json.pedido;
        this.Estado = Pedidos.Estados.toTipo( this.Json.estado );
        this.Fecha = !this.Json.fecha ? moment( '' ) : moment( this.Json.fecha );
        this.Usuario = !this.Json.usuario ? 0 : this.Json.usuario;


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IModificacionDeEstado ) {
        this.Model = Model;
    }

    public Model: IModificacionDeEstado;
}